import { durationFormatter } from '@/libs';

const duration = durationFormatter;

export default duration;
